import * as React from 'react';

import { css, cx } from 'emotion';
import { InvoiceAuthModel } from '../../../../models/invoice-auth.model';
import { Merchant } from '../../../../models/merchant.model';
import { MerchantContactInfo } from '../../../merchant-contact-info/merchant-contact-info.component';
import * as styles from '../payment-page.component.styles';

import { ReactComponent as ErrorIcon } from '../../../../images/wv-icon-circle-x.svg';
import EncryptIcon from '../../../../images/encrypt.png';
import HippaIcon from '../../../../images/hippa.png';

interface Props {
  auth: InvoiceAuthModel;
  uniqueLink: string;
  merchant?: Merchant;

  getInvoice: (uniqueCode: string, birthdate: string) => void;
}

interface State {
  birthdate: {
    year: string;
    month: string;
    day: string;
  };
}

export class Auth extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      birthdate: {
        year: '',
        month: '',
        day: '',
      },
    };
  }

  convertToDoubleDigit = (value: string) => {
    if (value.length === 1) {
      return `0${value}`;
    }

    return value;
  };

  getBirthdate = () => {
    const year = this.state.birthdate.year;
    const month = this.convertToDoubleDigit(this.state.birthdate.month);
    const day = this.convertToDoubleDigit(this.state.birthdate.day);

    return `${year}-${month}-${day}`;
  };

  handleBirthdateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    const birthdate = { ...this.state.birthdate, [name]: value };
    this.setState({ birthdate });
  };

  submitBirthdate = (event: React.FormEvent) => {
    event.preventDefault();
    this.props.getInvoice(this.props.uniqueLink, this.getBirthdate());
  };

  render() {
    const merchant = this.props.merchant;
    if (this.props.auth.lockedOut) {
      return (
        <div className={styles.resultMessage}>
          <h1>Authentication Error</h1>
          <p>
            You have reached the maximum number of authentication attempts. Please contact
            the sender to have them create and send you a new payment link.
          </p>
          <MerchantContactInfo merchant={merchant} />
          <ErrorIcon className={styles.errorIcon} />
        </div>
      );
    }

    return (
      <form className={styles.resultMessage} onSubmit={this.submitBirthdate}>
        <h2>Authentication Required</h2>
        <p className={styles.infoText}>
          This payment request includes a secure billing attachment. To view the
          attachment and see your amount due, please authenticate by filling in the
          information below.
        </p>

        <div
          className={cx(styles.birthdate, {
            [styles.birthdateError]: this.props.auth.attempted,
          })}
        >
          <span>Birthday of</span>
          <span className={styles.bold}>{this.props.auth.name}</span>
          <input
            name="month"
            type="tel"
            maxLength={2}
            value={this.state.birthdate.month}
            onChange={this.handleBirthdateChange}
            placeholder="MM"
          />
          <input
            name="day"
            type="tel"
            maxLength={2}
            value={this.state.birthdate.day}
            onChange={this.handleBirthdateChange}
            placeholder="DD"
          />
          <input
            name="year"
            type="tel"
            maxLength={4}
            value={this.state.birthdate.year}
            onChange={this.handleBirthdateChange}
            placeholder="YYYY"
          />
        </div>
        {this.props.auth.attempted && (
          <p className={styles.errorText}>
            Error: Invalid authentication attempt.
            <br />
            Please try again.
          </p>
        )}
        <button type="submit" className={styles.button}>
          Confirm
        </button>
        <div className={styles.securityBadges}>
          <img
            src={EncryptIcon}
            className={css`
              height: 50px;
            `}
            alt="Secure"
          />
          <img
            src={HippaIcon}
            className={css`
              height: 40px;
            `}
            alt="HIPPA Compliant"
          />
        </div>
      </form>
    );
  }
}
